module.exports = __webpack_public_path__ + "static/media/fly0257.2fe9329c.webp";